import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const styles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  cropContainer: {
    position: 'relative',
    width: 'min(85vw, 560px)',
    height: 'min(85vw, 420px)',
    margin: '0 auto',
  },
  zoomControls: {
    position: 'absolute',
    right: 16,
    bottom: 16,
    display: 'flex',
    gap: 8,
    zIndex: 2,
  },
  zoomButton: {
    backgroundColor: '#333',
    color: 'white',
    width: 40,
    height: 40,
    borderRadius: 8,
    border: 'none',
    boxShadow: '0 0 10px #0003',
  },
  actionsBar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    padding: '12px 16px',
    background: 'rgba(255,255,255,0.95)',
    zIndex: 3,
    display: 'flex',
    justifyContent: 'center',
    gap: 12,
  },
}));

const getCroppedImg = (image, croppedAreaPixels, filename, type) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        blob.name = filename;
        resolve(blob);
      },
      type || 'image/png',
      0.95,
    );
  });
};

const CropImageDialog = (props) => {
  const { opened, handleClose, preview, file, onConfirm } = props;
  const imgRef = React.useRef(null);
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);
  const classes = styles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const minZoom = 1;
  const maxZoom = 5;
  const step = 0.2;
  const zoomIn = () => setZoom((z) => Math.min(maxZoom, +(z + step).toFixed(2)));
  const zoomOut = () => setZoom((z) => Math.max(minZoom, +(z - step).toFixed(2)));

  return (
    <Dialog open={opened} onClose={handleClose} fullWidth maxWidth={'sm'} scroll='body' fullScreen={matches}>
      <div className={classes.paper} style={matches ? { padding: 8, borderRadius: 0 } : undefined}>
        <div className={classes.textRight}>
          <IconButton size='small' onClick={handleClose}>
            <i className='fa fa-times'></i>
          </IconButton>
        </div>
        <Box textAlign='center' style={{marginBottom: '16px'}}>
          <img src={preview} ref={imgRef} style={{ display: 'none' }} alt='hidden' />
          {!!preview && (
            <div className={classes.cropContainer} style={matches ? { width: '100%', height: 'calc(100vh - 200px)' } : undefined}>
              <Cropper
                image={preview}
                crop={crop}
                zoom={zoom}
                minZoom={minZoom}
                maxZoom={maxZoom}
                cropShape="rect"
                showGrid={true}
                restrictPosition={true}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={(area, areaPixels) => setCroppedAreaPixels(areaPixels)}
              />
              <div className={classes.zoomControls} style={matches ? { position: 'fixed', left: 0, right: 0, bottom: 128, justifyContent: 'center' } : undefined}>
                <button className={classes.zoomButton} type='button' onClick={zoomOut}>
                  <i className='fa fa-minus'></i>
                </button>
                <button className={classes.zoomButton} type='button' onClick={zoomIn}>
                  <i className='fa fa-plus'></i>
                </button>
              </div>
            </div>
          )}
        </Box>
        {!!preview && (
          matches ? (
            <Box className={classes.actionsBar}>
              <Button
                type='button'
                component='label'
                variant='outlined'
                color='primary'
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                type='button'
                component='label'
                variant='contained'
                color='primary'
                onClick={async () => {
                  const blob = await getCroppedImg(
                    imgRef.current,
                    croppedAreaPixels,
                    file ? file.name : 'upload.png',
                    file ? file.type : 'image/png'
                  );
                  onConfirm(blob);
                  handleClose();
                }}
              >
                Confirmar recorte
              </Button>
            </Box>
          ) : (
            <>
              <Button
                type='button'
                component='label'
                variant='outlined'
                color='primary'
                onClick={handleClose}
              >
                Cancelar
              </Button>
              &nbsp;
              <Button
                type='button'
                component='label'
                variant='contained'
                color='primary'
                onClick={async () => {
                  const blob = await getCroppedImg(
                    imgRef.current,
                    croppedAreaPixels,
                    file ? file.name : 'upload.png',
                    file ? file.type : 'image/png'
                  );
                  onConfirm(blob);
                  handleClose();
                }}
              >
                Confirmar recorte
              </Button>
            </>
          )
        )}
      </div>
    </Dialog>
  );
};

export default CropImageDialog;
